<div class="dtf-anchor" #anchor>
  <ion-item
    lines="none"
    detail="false"
    class="dtf-item pe-date-item"
    [class.dtf-invalid]="!!error"
    [class.dtf-disabled]="disabled">
    <ion-input
      type="text"
      [placeholder]="placeholder"
      [(ngModel)]="text"
      [ngModelOptions]="{standalone: true}"
      [disabled]="disabled"
      autocomplete="off"
      (ionFocus)="onFocus()"
      (ionInput)="onTyping($event)"
      (ionBlur)="onBlur()"
      (keyup.enter)="onBlur()">
    </ion-input>
    <ion-icon
      name="close-circle-outline"
      class="dtf-clear"
      *ngIf="text && !disabled"
      slot="end"
      aria-label="Clear date"
      (mousedown)="$event.preventDefault()"
      (click)="onClear($event)">
    </ion-icon>
    <ion-icon
      name="calendar"
      class="dtf-calendar"
      *ngIf="!disabled"
      slot="end"
      [attr.aria-label]="dateOnly ? 'Choose date' : 'Choose date and time'"
      (click)="togglePicker($event)">
    </ion-icon>
  </ion-item>
  <div class="dtf-error error-message" *ngIf="error">{{ error }}</div>
</div>
<app-product-datetime-picker
  *ngIf="pickerOpen && !disabled"
  [dateOnly]="dateOnly"
  [anchor]="popupAnchor || anchor"
  [value]="pickerValue"
  (accepted)="onPicked($event)"
  (dismissed)="onDismiss()">
</app-product-datetime-picker>
